var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#964B9C"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.507 16.406l-4.472 4.471h8.942l-4.47-4.471z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.528 16.41L16 11.94H7.057l4.472 4.471z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.035 20.878l4.46-4.46-4.48-4.482-8.943 8.942 8.942 8.943 8.943-8.943h-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.056 3l-8.937 8.937H16l-4.446 4.446 4.502 4.501 8.942-8.942z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShift);
export default __webpack_public_path__ + "static/media/shift.511b26aafc8db0bafaa66c35d2f7c444.svg";
export { ForwardRef as ReactComponent };